import { Flex, Heading } from '@chakra-ui/react'
import Logo from './assets/logo-comp.png'
import Theme from './theme/theme'
import { Calc } from './screens/Calc'

export const App: React.FC = () => {
  return (
    <Flex w="100%">
      <Flex flex={1} direction="column">
        <Flex
          flex={1}
          direction="row"
          backgroundColor="#290c3c"
          shadow={Theme.shadows.nrr.light}
          paddingY="14px"
          alignItems="center"
          justifyContent="center"
        >
          <img src={Logo} alt="ICC U19 Men's Cricket World Cup 2022" width="228px" height="66px" />
          <Heading as="h1" size="lg" marginLeft="28px" color="#FFFFFF">
            Net Run Rate Calculator
          </Heading>
        </Flex>
        <Flex flex={1} padding="14px">
          <Calc />
        </Flex>
      </Flex>
    </Flex>
  )
}
